var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_GENERAL_TIMEOUT = 10000;
class TimeoutError extends Error {
}
class Timeout {
    constructor(options) {
        this.timeout = options.ms || DEFAULT_GENERAL_TIMEOUT;
        this.id = undefined;
    }
    begin() {
        return new Promise((_resolve, reject) => {
            this.id = setTimeout(() => reject(new TimeoutError(`Call timed out at ${this.timeout}ms`)), Number(this.timeout));
        });
    }
    end() {
        this.id && clearTimeout(this.id);
    }
}
const timeout = (promiseCb, ms = DEFAULT_GENERAL_TIMEOUT, controller) => new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
    const timeoutID = setTimeout(() => {
        reject(new TimeoutError(`Call timed out at ${ms}ms`));
        controller.abort();
    }, Number(ms));
    try {
        resolve(yield promiseCb(timeoutID));
    }
    catch (e) {
        reject(e);
    }
    finally {
        clearTimeout(timeoutID);
    }
}));
export default timeout;
export { Timeout, TimeoutError };
//# sourceMappingURL=timeout.js.map